import {StyleSheet} from 'react-native';
import React from 'react';
const UISvg = props => {
   const HEIGHT = props?.height ?? '100%';
   const WIDTH = props?.width ?? '100%';
   const x1 = props?.x1 ?? '100%';
   const x2 = props?.x2 ?? '100%';
   const y1 = props?.y1 ?? '100%';
   const y2 = props?.y2 ?? '100%';
   const StopList = () => {
      return props.stopColor.map((item, i) => {
         let stopColor = '#003DA500',
            offset = '0%',
            stopOpacity = '0';
         if (props.stopColor && props.stopColor[i]) {
            stopColor = props?.stopColor[i];
         }
         if (props.offset && props.offset[i]) {
            offset = props?.offset[i];
         }
         if (props.stopOpacity && props.stopOpacity[i]) {
            stopOpacity = props?.stopOpacity[i];
         }
         return (
            <stop
               key={i}
               offset={offset}
               stopColor={stopColor}
               stopOpacity={stopOpacity}
            />
         );
      });
   };
   const divID = `grad${Date.now()}`;
   return (
      <div style={{zIndex: -1}}>
         <svg
            height={HEIGHT}
            width={WIDTH}
            style={StyleSheet.absoluteFillObject}>
            <defs>
               <linearGradient id={divID} x1={x1} y1={y1} x2={x2} y2={y2}>
                  {StopList()}
               </linearGradient>
            </defs>
            <rect width="100%" height="100%" fill={`url(#${divID})`} />
         </svg>
      </div>
   );
};

export default React.memo(UISvg);
